module.exports = __webpack_public_path__ + "static/julesMobile-8e9f515d58bbbda527424ae2c66e4b89.png";